import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PortalLogin from './pages/PortalLogin';
import PortalLayout from './components/PortalLayout';
import { PortalAuthProvider, usePortalAuth } from './context/PortalAuthContext';

const PortalGuard = ({ children }) => {
  const { session } = usePortalAuth();
  if (!session) {
    return <Navigate to="/portal/login" replace />;
  }
  return children;
};

export default function PortalApp() {
  return (
    <PortalAuthProvider>
      <Routes>
        <Route path="login" element={<PortalLogin />} />
        <Route
          path="*"
          element={
            <PortalGuard>
              <PortalLayout />
            </PortalGuard>
          }
        />
      </Routes>
    </PortalAuthProvider>
  );
}
